import request from '@/utils/request'
import CONSTANTS from '@/configs/constants'
import { getApiUrl } from '@/utils/string'
import { setToken, removeToken } from '@/utils/auth'

const state = {
    user: null,
    userRegistered: null,
}

const getters = {
    authenticated(state) {
        return !!state.user?.id
    },
    user(state) {
        return state.user
    },
    id(state) {
        return state.user?.id
    },
    name(state) {
        return state.user?.name
    },
    email(state) {
        return state.user?.email
    },
    isAdmin(state) {
        return state.user?.isAdmin
    },
    registeredEmail(state) {
        return state.userRegistered?.email
    },
}

const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setRegisteredUser(state, user) {
        state.userRegistered = user
    },
}

const actions = {
    login({ commit }, payload) {
        return new Promise((resolve, reject) => {
            request.post(getApiUrl(CONSTANTS.URL_USER_LOGIN), payload)
                .then(res => {
                    if (!res?.success) {
                        reject()
                    }

                    setToken(res.data.token)
                    commit('setUser', res.data)
                    resolve(res)
                })
                .catch(reject)
        })
    },
    logout({ commit }) {
        return new Promise((resolve) => {
            removeToken()
            commit('setUser', null)
            commit('setRegisteredUser', null)
            resolve()
        })
    },
    fresh({ commit }) {
        return new Promise((resolve, reject) => {
            request.post(getApiUrl(CONSTANTS.URL_USER_FRESH))
                .then(res => {
                    if (!res?.success) {
                        reject()
                    }

                    setToken(res.data.token)
                    commit('setUser', res.data)
                    resolve(res)
                })
                .catch(err => {
                    removeToken()
                    reject(err)
                })
        })
    },
    register({ commit }, payload) {
        return new Promise((resolve, reject) => {
            request.post(getApiUrl(CONSTANTS.URL_USER_REGISTER), payload)
                .then(res => {
                    if (!res?.success) {
                        reject()
                    }

                    commit('setRegisteredUser', res.data)
                    resolve(res)
                })
                .catch(reject)
        })
    },
    update({ getters, commit }, payload) {
        return new Promise((resolve, reject) => {
            request.put(getApiUrl(CONSTANTS.URL_USER_UPDATE, { userId: getters.id }), payload)
                .then(res => {
                    if (!res?.success) {
                        reject()
                    }

                    commit('setUser', res.data)
                    resolve(res)
                })
                .catch(reject)
        })
    },
    updatePassword({ getters, commit }, payload) {
        return new Promise((resolve, reject) => {
            request.put(getApiUrl(CONSTANTS.URL_USER_UPDATE_PASSWORD, { userId: getters.id }), payload)
                .then(res => {
                    if (!res?.success) {
                        reject()
                    }

                    commit('setUser', res.data)
                    resolve(res)
                })
                .catch(reject)
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
